export default{

	controller: false,

	init(){
		this.controller = new ScrollMagic.Controller();

		var items = document.querySelectorAll('.bread-item')

		for (var i = 0; i < items.length; i++) {
			items[i]					

			var tween = new TimelineMax();
			var title = items[i].querySelector('h2')
			var thumb = items[i].querySelector('.bread-thumbnail')
			var content = items[i].querySelector('.bread-content')
			var itemsGallery = items[i].querySelectorAll('.bread-content figure')
			tween.fromTo(title, 0.4, {y: 30, opacity: 0}, {y: 0, opacity: 1, ease: Power2.easeOut})
			tween.fromTo(thumb, 0.8, {y: 40, scale: 0.95, opacity: 0}, {y: 0, scale: 1, opacity: 1, ease: Power2.easeOut}, .3)
			tween.fromTo(content, 0.8, {y: 40, opacity: 0}, {y: 0, opacity: 1, ease: Power2.easeOut}, .5)
			tween.staggerFromTo(itemsGallery, 0.4, {scale: 0.9, opacity: 0}, {scale: 1, opacity: 1, ease: Power2.easeOut}, .25, .7)

			var scene = new ScrollMagic.Scene({
				triggerElement: items[i],
				offset: -50
			// triggerHook: 'onEnter'
			})
			.setTween(tween)
			.addTo(this.controller)

			// scene.addIndicators();

		}

	}

}